export const roles = {
    ROLE_ERP: 'Colaborador',
    ROLE_ARREMATANTE: 'Leiloeiro',
    //ROLE_COMITENTE: 'Comitente',
    //ROLE_PARCEIRO: 'Parceiro',
    //ROLE_PRESTADOR: 'Prestador',
    //ROLE_VISTORIADOR: 'Vistoriador',
    //ROLE_REBOQUISTA: 'Reboquista'
}
